import React, { useMemo } from "react";
import { Table, Tag } from "antd";
import dayjsTZ from "../../../../utils/dayjs";
import { STATUS_COLORS } from "../utils/statusColors";

const PlanerListView = ({ leave = [], employees = [], onRowClick }) => {
  const empBySub = useMemo(() => {
    const map = {};
    (employees || []).forEach((e) => {
      if (e.userSub) map[e.userSub] = e;
    });
    return map;
  }, [employees]);

  const nameOf = (r) => {
    const emp = empBySub[r.userSub];
    return (
      (
        emp
          ? `${emp.employeeFirstName || ""} ${emp.employeeLastName || ""}`.trim()
          : `${r.given_name || ""} ${r.family_name || ""}`.trim()
      ) || "—"
    );
  };

  const dataSource = useMemo(
    () =>
      [...(leave || [])].sort((a, b) =>
        nameOf(a).localeCompare(nameOf(b), "sq", { sensitivity: "base" })
      ),
    [leave, empBySub]
  );

  const columns = [
    {
      title: "Punonjësi",
      key: "name",
      render: (_, r) => nameOf(r),
      sorter: (a, b) =>
        nameOf(a).localeCompare(nameOf(b), "sq", { sensitivity: "base" }),
      defaultSortOrder: "ascend",
    },
    {
      title: "Departamenti",
      key: "dept",
      width: 160,
      render: (_, r) =>
        empBySub[r.userSub]?.employeeDepartmentName ||
        r.employeeDepartmentName ||
        "—",
    },
    {
      title: "Ekipi",
      key: "team",
      width: 120,
      render: (_, r) =>
        empBySub[r.userSub]?.employeeTeam || r.employeeTeam || "—",
    },
    {
      title: "Lloji",
      dataIndex: "requestType",
      width: 140,
    },
    {
      title: "Fillimi",
      key: "start",
      width: 120,
      render: (_, r) =>
        r.requestPeriod?.[0]
          ? dayjsTZ(r.requestPeriod[0]).format("DD/MM/YYYY")
          : "—",
      sorter: (a, b) =>
        (a.requestPeriod?.[0] || 0) - (b.requestPeriod?.[0] || 0),
    },
    {
      title: "Mbarimi",
      key: "end",
      width: 120,
      render: (_, r) =>
        r.requestPeriod?.length
          ? dayjsTZ(r.requestPeriod.at(-1)).format("DD/MM/YYYY")
          : "—",
    },
    {
      title: "Ditë",
      key: "days",
      width: 70,
      align: "center",
      render: (_, r) => r.requestPeriod?.length || 0,
    },
    {
      title: "Statusi",
      dataIndex: "requestStatus",
      width: 120,
      render: (status) => (
        <Tag
          color={STATUS_COLORS[status] || "#888"}
          style={{ color: "#fff", border: "none" }}
        >
          {status}
        </Tag>
      ),
      filters: Object.keys(STATUS_COLORS).map((s) => ({ text: s, value: s })),
      onFilter: (value, record) => record.requestStatus === value,
    },
  ];

  return (
    <div className="planer-list-view">
      <Table
        rowKey="requestId"
        size="middle"
        columns={columns}
        dataSource={dataSource}
        pagination={{ pageSize: 20, showSizeChanger: true }}
        onRow={(record) => ({
          onClick: () => onRowClick?.(record),
          style: { cursor: "pointer" },
        })}
        locale={{ emptyText: "Nuk ka kërkesa për këtë muaj / filtra." }}
      />
    </div>
  );
};

export default PlanerListView;
